var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_232",
    "data-name": "Path 232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,36H11.83A4.8,4.8,0,0,1,7,31.17V8.77A4.8,4.8,0,0,1,11.83,4h10.9a1.57,1.57,0,0,1,1.11.45l8.51,8.17a1.6,1.6,0,0,1,.49,1.16V31.17A4.8,4.8,0,0,1,28,36ZM11.83,7.17a1.6,1.6,0,0,0-1.6,1.6v22.4a1.6,1.6,0,0,0,1.6,1.6H28a1.6,1.6,0,0,0,1.6-1.6V14.43L22.09,7.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_233",
    "data-name": "Path 233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.24,16.56H24.13a4,4,0,0,1-4-4V5.74a1.6,1.6,0,1,1,3.2,0v6.82a.8.8,0,0,0,.8.8h7.11a1.6,1.6,0,1,1,0,3.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/PageIcon.9409d8b0d20e84904489eb78e1a59c8b.svg";
export { ForwardRef as ReactComponent };